var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpatulaSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_419_3193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.398 3.91569L20.1006 0.618267C19.2762 -0.206089 17.8523 -0.206089 17.028 0.618267L13.8804 3.76581C12.6064 4.96487 12.2317 6.83841 12.8312 8.41218L0.615772 20.7026C-0.133643 21.452 -0.133643 22.726 0.615772 23.4754C0.990479 23.7752 1.51507 24 2.03966 24C2.56425 24 3.0139 23.8501 3.38861 23.4754L3.46355 23.4005L15.0795 11.26C15.5291 11.4098 15.9788 11.4848 16.4284 11.4848C17.4776 11.4848 18.4518 11.0351 19.2762 10.2857L21.9741 7.88759L23.0982 7.06323L23.1732 6.98829C23.9975 6.16394 24.2973 4.81499 23.398 3.91569ZM22.124 5.93911L21.0748 6.76347L18.302 9.16159C17.4027 9.98595 16.3535 10.2108 15.3043 9.68618C15.0045 9.5363 14.6298 9.61124 14.405 9.83607L2.41437 22.2764C2.41437 22.2764 2.41437 22.2764 2.33943 22.3513C2.18954 22.5012 1.88978 22.5012 1.66495 22.3513C1.51507 22.2014 1.51507 21.9016 1.66495 21.7518L14.1802 9.23654C14.405 9.01171 14.4799 8.637 14.3301 8.41218C13.7305 7.28806 14.0303 5.86417 14.9296 4.96487L18.0771 1.81733C18.227 1.59251 18.3769 1.51756 18.6017 1.51756C18.7516 1.51756 18.9764 1.59251 19.0514 1.74239L22.3488 5.03981C22.5736 5.26464 22.4237 5.71429 22.124 5.93911Z",
    fill: "#9393B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0513 3.16623C18.7515 2.86646 18.3018 2.86646 18.0021 3.16623L15.3791 5.78918C15.0794 6.08895 15.0794 6.5386 15.3791 6.83836C15.529 7.06319 15.7538 7.06319 15.9037 7.06319C16.1285 7.06319 16.2784 6.98825 16.4283 6.83836L19.0513 4.21541C19.351 3.91565 19.351 3.466 19.0513 3.16623Z",
    fill: "#9393B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8501 4.96506C20.5503 4.66529 20.1007 4.66529 19.8009 4.96506L17.1779 7.58801C16.8782 7.88778 16.8782 8.33742 17.1779 8.63719C17.3278 8.78707 17.5527 8.86202 17.7025 8.86202C17.8524 8.86202 18.0772 8.78707 18.2271 8.63719L20.8501 6.01424C21.1498 5.71447 21.1498 5.26482 20.8501 4.96506Z",
    fill: "#9393B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_419_3193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpatulaSvgrepocom);
export default __webpack_public_path__ + "static/media/spatula_svgrepo.com.a9ce221d439666724401c5320dcd47b3.svg";
export { ForwardRef as ReactComponent };